import {NgModule} from '@angular/core';
import {
  Routes,
  RouterModule,
} from '@angular/router';
import {PageStartComponent} from './pages/page-start/page-start.component';
import {PageVkComponent} from './pages/page-vk/page-vk.component';
import {PageCalcComponent} from './pages/page-calc/page-calc.component';
import { PageLeadsComponent } from './pages/page-leads/page-leads.component';
import { PageScanTasksComponent } from './pages/page-scan-tasks/page-scan-tasks.component';

const routes: Routes = [
  {
    path: 'call', component: PageCalcComponent, data: {},
  },
  {
    path: 'call/:id', component: PageCalcComponent, data: {}
  },
  {path: 'leads', component: PageLeadsComponent, data: {animation: '1'}},
  {path: 'tasks', component: PageScanTasksComponent, data: {animation: '1'}},
  {
    path: '',
    component: PageStartComponent,
    data: {animation: '1'},
    children: [
      {path: 'call', component: PageCalcComponent, data: {}},
      {path: ':id', component: PageVkComponent, data: {animation: '5'}},
    ]
  },
  {path: '*', component: PageStartComponent, data: {animation: '1'}},
  {path: 'chat', component: PageStartComponent, data: {animation: '1'}}
  /*{ path: 'skype', component: PageSkypeComponent, data: {animation: '2', reuseRoute: true}},
  { path: 'vk', component: PageVkComponent, data: {animation: '2', reuseRoute: true}, children: [
      {path: 'chat/:id', component: PageVkComponent, data: {animation: '5'}},
    ]},
  { path: 'whatsapp', component: PageWhatsappComponent, data: {animation: '2', reuseRoute: true}, children: [
      {path: 'chat/:id', component: PageVkComponent, data: {animation: '5'}},
    ]},
  { path: 'telegram', component: PageTelegramComponent, data: {animation: '4', reuseRoute: true},
    children: [
      {path: 'chat/:id', component: PageTelegramComponent, data: {animation: '5'}},
    ]},
  { path: 'all', component: PageStartComponent, data: {animation: '6', reuseRoute: true}, children: [
      {path: ':type/:id', component: PageStartComponent, data: {animation: '7'}},
    ]},*/
];

// routes.push({ path: '**', component: PageNotFoundComponent, data: {animation: '25', title: 'Страница не найдена'} });

// routes.push({ path: '**', component: PageNotFoundComponent, data: {animation: '25', title: 'Страница не найдена'} });

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
